import { Cancel } from './Cancel';
import { CodeDeployed } from './CodeDeployed';
import { Home } from './Home';
import { LinkedInLogo } from './LinkedInLogo';
import { MenuBookOutline } from './MenuBookOutline';
import { News } from './News';
import { Sdk } from './Sdk';
import { Warning } from './Warning';
import { Trophy } from './Trophy';
import { XTwitterLogo } from './XTwitterLogo';
import { Info } from './Info';
import { Add } from './Add';
import { Unassigend } from './Unassigned';
import { Calendar } from './Calendar';
import { Pen } from './Pen';
import { Edit } from './Edit';
import { Cert } from './Cert';

export const SvgIcon = {
  CodeDeployed: CodeDeployed,
  home: Home,
  news: News,
  sdk: Sdk,
  cancel: Cancel,
  menu_book_unshaded: MenuBookOutline,
  warning: Warning,
  info: Info,
  MenuBookUnshaded: MenuBookOutline,
  XTwitterLogo,
  LinkedInLogo,
  Trophy,
  add: Add,
  unassigned: Unassigend,
  calendar: Calendar,
  pen: Pen,
  edit: Edit,
  cert: Cert,
};
